export default __webpack_public_path__ + "static/media/zoom.066c19f5.svg";